import { EventCard, FormattedEvent } from '@eventbrite/event-renderer';
import React from 'react';
import styles from './EventCardContainer.module.scss';

export const POINTS_OF_INTEREST_AFF_CODE = 'ebdssbpointsofinterest';
export interface EventCardContainerProps {
    isAuthenticated: boolean;
    eventData: FormattedEvent;
    currencyFormat: string;
}

export const EventCardContainer = (props: EventCardContainerProps) => {
    const { eventData, isAuthenticated } = props;

    return (
        <div className={styles.eventCard}>
            <EventCard
                isAuthenticated={isAuthenticated}
                eventData={eventData}
                shouldConvertToUserTimezone={true}
                type={'grid'}
                isLazyImage={true}
                affCode={POINTS_OF_INTEREST_AFF_CODE}
                shouldShowIcons={true}
                isTargetBlank={true}
            />
        </div>
    );
};
